export const rangeExplorerActions = {
  UPDATE_SUITS_FOR_FILTER_RE: 'UPDATE_SUITS_FOR_FILTER_RE',
  UPDATE_DECISION_FILTER_RE: 'UPDATE_DECISION_FILTER_RE',
  CHANGE_CLICKED_HAND_ITEM_RE: 'CHANGE_CLICKED_HAND_ITEM_RE',
  UPDATE_HAND_CATEGORY: 'UPDATE_HAND_CATEGORY',
  FETCHING_RANGE_EXPLORER_DATA: 'FETCHING_RANGE_EXPLORER_DATA'
}
